export { PlaceholderIcon as MouthTingleIcon } from "./placeholder";
